﻿const ALL_VALUE = 'alles';

document.addEventListener('DOMContentLoaded', () => {
    const $filters = Array.prototype.slice.call(document.querySelectorAll('.is-filter'), 0);

    if ($filters.length > 0) {
        const urlParams = new URLSearchParams(window.location.search);
        const filterParams = [...new Set($filters.map(el => el.dataset.param))];

        filterParams.forEach(param => {
            let activeEl;
            if (urlParams.has(param) && document.querySelector('.is-filter[data-param="' + param + '"][data-value="' + urlParams.get(param) + '"]')) {
                activeEl = document.querySelector('.is-filter[data-param="' + param + '"][data-value="' + urlParams.get(param) + '"]');
            }
            else {
                activeEl = document.querySelector('.is-filter[data-param="' + param + '"][data-value="' + ALL_VALUE + '"]');
            }

            activeEl.classList.add('is-active');
        });

        $filters.forEach(el => {
            el.addEventListener('click', () => {
                if (el.classList.contains('is-active')) {
                    return;
                }

                const newUrlParams = new URLSearchParams();
                const clickedParam = el.dataset.param;
                
                $filters.forEach(filterEl => {
                    if (filterEl.dataset.param == clickedParam) {
                        filterEl.classList.remove('is-active');
                    }
                });

                el.classList.add('is-active');

                filterParams.forEach(param => {
                    const activeEl = document.querySelector('.is-filter.is-active[data-param="' + param +'"]')
                    if (activeEl.dataset.value != ALL_VALUE) {
                        newUrlParams.append(param, activeEl.dataset.value);
                    }
                });

                let url = window.location.href.split('?')[0];
                url = newUrlParams.toString() ? url + '?' + newUrlParams.toString() : url;
                window.location.href = url;
            });
        });
    }
});